
  import { defineComponent, onMounted, defineExpose, ref, computed, reactive } from 'vue'
  import { Plus } from '@element-plus/icons-vue'
  import { getToken } from '@/utils/auth'
  import request from '@/utils/request'
  import { ElMessageBox  } from 'element-plus/lib/components';
  import {upload} from '@/api/upload'
  import type { UploadProps, UploadUserFile  } from 'element-plus'
  import { ElMessage } from 'element-plus'
  import {fa} from "element-plus/es/locale";
  export  default  defineComponent({
    name:"ui-image",
    props:{
      value:{
        type:Array,
      },
      url:{
        type:String,
        // default:'https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15'
        default:process.env.VUE_APP_SERVER_API+'upload'  //上传图片地址
      },
      header:{
        type:Object,
        default:{
          Authorization:getToken()
        }
      },
      limit:{
        type:Number,
        default:1
      },
      multiple:{
        type:Boolean,
        default:false
      },
      upload: {
        type: Boolean,
        default: false
      }
    },
    emits:['input'],
    setup(props,ctx){
      const dialogImageUrl:any = ref(false)
      const dialogVisible:any = ref(false)
      const uploadDisabled:any = ref(false)
      const handleRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
        // if(uploadFiles.length>=props.limit){
        //   uploadDisabled.value = true
        // }else{
        //   uploadDisabled.value = false
        // }
      }
      const handleSuccess: UploadProps['onSuccess'] = (uploadFile, uploadFiles) => {
        console.log("success",uploadFile)
        console.log(uploadFile)
        let arr = []
        arr.push({
          response:{
            data:uploadFile.data
          }
        })
        ctx.emit('input',getUploadImg(arr))
      }
      const handlePictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
        dialogImageUrl.value = uploadFile.url!
        dialogVisible.value = true
      }
      const handleError: UploadProps['onError'] = (error) => {
        console.log("error",error)
      }
      const handleExceed = (files) => {
        ElMessage({
          showClose: true,
          message: `图片只能上传${props.limit}张`,
          type: 'error',
        })

      }
      const handleChange = (uploadFile, uploadFiles) => {
        console.log(uploadFile.response,uploadFile.name)
        // if(uploadFile.response.code == "999999"){
        //   ElMessage({
        //     showClose: true,
        //     message: '添加成功',
        //     type: 'success',
        //   })
        // }
        // if(uploadFiles.length>=props.limit){
        //   uploadDisabled.value = true
        // }
      }
      const handleBeforeUpload = (uploadFile) => {

        if(uploadFile.size / 1024 / 1024 > 1){
            ElMessage({
              showClose: true,
              message: '图片大小不能超过1M',
              type: 'error',
            })
          return false
        }
        return  true
      }
      const getUploadImg = (file) => {
        console.log(file)
        let arr = []
        if(file.length==0){
          return arr
        }
        for(let i =0;i<file.length;i++){
          arr.push(file[i].response.data)
        }
        return  arr
      }
      //未启用
      const handleUpload = (params) => {
        let formData = new FormData()
        formData.append('file', params.file)
        request({
          url:props.url.toString(),
          method: 'post',
          data:formData
        })
      }
      onMounted(() => {
        // const fileList = props.value as any
        // console.log(fileList.length)
        // if(fileList.length >= props.limit){
        //   uploadDisabled.value = true
        // }else{
        //   uploadDisabled.value = false
        // }
      })
      return{
        dialogImageUrl,
        dialogVisible,
        uploadDisabled,
        handleRemove,
        handleError,
        handleChange,
        handleExceed,
        handlePictureCardPreview,
        handleSuccess,
        handleUpload,
        handleBeforeUpload,
        getUploadImg
      }
    }
  })
